import { Span, startInactiveSpan } from '@sentry/browser';

export const startTransaction = (name: string) =>
  startInactiveSpan({ name, forceTransaction: true });

export const endTransaction = (
  transaction: Span,
  tags: Record<string, string | number | boolean>
) => {
  for (const [k, v] of Object.entries(tags)) {
    transaction.setAttribute(k, v);
  }
  transaction.end();
};

type CompletedTransaction = {
  name: string;
  startTime: number;
  endTime: number;
  attributes: Record<string, string | number | boolean>;
};

export const recordCompletedTransaction = ({
  name,
  startTime,
  endTime,
  attributes,
}: CompletedTransaction): void =>
  startInactiveSpan({
    name,
    startTime,
    attributes,
    forceTransaction: true,
  }).end(endTime);

export const startSpan = (transaction: Span, description: string) =>
  startInactiveSpan({ name: description, parentSpan: transaction });

export const endSpan = (span: Span) => span.end();
